import { listToObj } from 'utils/util'

// 申请来源
export const SOURCE_LIST = [
  {
    text: '全部',
    value: 0,
  },
  {
    text: 'Le-Credit',
    value: 1,
  },
  {
    text: 'CRM',
    value: 2,
  },
]

// 审核状态
export const AUDIT_STATUS_OBJ = {
  0: {
    text: '待审核',
    color: 'blue',
  },
  1: {
    text: '待审批',
    color: 'purple',
  },
  2: {
    text: '成功',
    color: 'green',
  },
  3: {
    text: '失败',
    color: 'red',
  },
}

// 审批操作
export const APPROVAL_ACTION_OBJ = {
  PASS: 1,
  REJECT: 2,
}

// 申请时可选的信用类型list
export const CREDIT_TYPE_LIST = [
  {
    label: '信用限额',
    value: '1',
  },
  {
    label: '正常额度',
    value: '2',
  },
  {
    label: '临时额度',
    value: '3',
  },
  {
    label: '专项额度',
    value: '4',
  },
  {
    label: '信用限额 + 正常额度',
    value: '5',
  },
  {
    label: '信用限额 + 临时额度',
    value: '6',
  },
  {
    label: '信用限额 + 专项额度',
    value: '7',
  },
]

// 信用类型的key-value对象
export const CREDIT_TYPE_OBJ = listToObj(CREDIT_TYPE_LIST)